import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import  '../scss/components/payment.scss';
import { cartSelector, clearItems } from '../redux/slices/cartSlice';

const Payment = () => {
    const dispatch = useDispatch();
    const { totalPrice, items } = useSelector(cartSelector);
    const totalCount = items.reduce((sum, item) => sum + item.count, 0);

    const onClickClear = () => {
          dispatch(clearItems());
      };
  return (
    <div className='container'>
        <h2>Оплатите Ваш заказ</h2>
        <div className="payment-wrapper">
            <p>Сумма заказа: <b>{totalPrice} ₽</b></p>
            <p>Количество продуктов в корзине: <b>{totalCount}</b></p>
            <div className="form-container">
            <form action="">
            <p>
                <label htmlFor="number-card" className='form-group'>Адрес для доставки заказа:</label>
                <input type="text" name='address' required placeholder='Введите адрес' />
                </p>
               <p>
                <label htmlFor="card" className='form-group'>Выберите тип банковской карты:</label>
               <select name="card" id="card-type">
               <option value="Выберите тип банковской карты">Выберите тип банковской карты</option>
                <option value="VISA">VISA</option>
                <option value="MasterCard">MasterCard</option>
               </select>
               </p> 
                <p>
                 <label htmlFor="number-card" className='form-group'>Номер банковской карты:</label>
                <input type="text" required placeholder='Введите номер карты' />
                </p>
                <p>
                <label htmlFor="name" className='form-group'>Имя держателя банковской карты:</label>
                <input type="text" required placeholder='Введите имя и фамилию' />
                </p>
                <p>
                <label htmlFor="cvc-code" className='form-group'>CVC код:</label>
                <input type="text" required placeholder='Введите CVC код' />
                </p>
                <Link to='/thanks'>
                <div onClick={onClickClear} className="button pay-btn">
                <span>Завершить оплату</span>
            </div>
            </Link>
            </form>
           
            </div>
        </div>
    </div>
  )
}

export default Payment